import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

export enum LMSCoursePageType {
  VIDEO = 'video',
  QUESTION = 'question',
}

@Entity()
export class LMSCoursePage extends MongoEntity {
  static override _class = 'LMSCoursePage';
  static override _collectionName = 'lms_course_pages';

  @validate(nonOptional())
  @Field(() => String)
  courseId: Maybe<string>;

  @validate(nonOptional())
  @Field(() => Int)
  order: Maybe<number>;

  @validate(nonOptional())
  @Field(() => String)
  type: Maybe<LMSCoursePageType>;

  @Field(() => String)
  title: Maybe<string>;

  @Field(() => String)
  videoUrl: Maybe<string>;

  @Field(() => String)
  questionText: Maybe<string>;

  @Field(() => [LMSAnswerOption])
  answerOptions: Maybe<LMSAnswerOption[]>;

  @Field(() => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;
}

@Entity()
export class LMSAnswerOption extends AdornisEntity {
  static override _class = 'LMSAnswerOption';

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @Field(() => String)
  text: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  isCorrect: Maybe<boolean>;
}
